export default (function (_ref) {
  var request = _ref.request;
  return {
    labProductionAdd: function labProductionAdd(data) {
      return request({
        url: '/mng/labProduction/add',
        method: 'post',
        data: data
      });
    },
    labProductionModify: function labProductionModify(data) {
      return request({
        url: "/mng/labProduction/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    labProductionDel: function labProductionDel(id) {
      return request({
        url: "/mng/labProduction/".concat(id, "/del"),
        method: 'delete'
      });
    },
    labProductionQuery: function labProductionQuery(data) {
      return request({
        url: '/mng/labProduction/query',
        method: 'get',
        params: data
      });
    },
    labProductionDetail: function labProductionDetail(id) {
      return request({
        url: "/mng/labProduction/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});